import { AccessTypeKey, AccessTypeRight } from '../Types/access';
import { Role } from '../Types/role';
import { User } from '../Types/user';

export function isAdministrator(user: User | undefined) {
	if (!user) return false;
	const adminRoleSystemNames = ['ADMINISTRATOR', 'PortalAdmin', 'HostAdmin'];
	return user.Roles ? user.Roles.some((role) => adminRoleSystemNames.includes(role.SystemName)) : false;
}

export function isPortalSuperadmin(user: User | undefined) {
	if (!user || !isAdministrator(user)) return false;

	return user.UserName?.toLowerCase() == 'superadmin';
}

export function hasModuleAccess(
	user: User | undefined,
	accessTypeModuleKey: AccessTypeKey,
	accessTypeAccess: AccessTypeRight | undefined
): boolean;
export function hasModuleAccess(
	user: User | undefined,
	accessTypeModuleKey: string,
	string: AccessTypeRight | undefined
): boolean;
export function hasModuleAccess(
	user: User | undefined,
	accessTypeModuleKey: AccessTypeKey | string,
	accessTypeAccess: AccessTypeRight | undefined
) {
	const atAccess = accessTypeAccess ?? 0;
	if (!accessTypeModuleKey && atAccess <= 0) return true;
	if (!user) return false;
	if (isAdministrator(user)) return true;

	if (user.Roles && anyRoleHasModuleAccess(user.Roles, accessTypeModuleKey, atAccess)) {
		return true;
	}

	// Session responses use UnitsAndParentUnits; retain AllUnits for older callers.
	const units = user.UnitsAndParentUnits ?? user.AllUnits;
	if (units) {
		for (let i = 0; i < units.length; i++) {
			const roles = units[i].Roles;
			if (roles && anyRoleHasModuleAccess(roles, accessTypeModuleKey, atAccess)) {
				return true;
			}
		}
	}

	return false;
}

export function hasAnyAccessTypeAccess(user: User | undefined, accessTypeAccess: AccessTypeRight): boolean {
	if (!user) return false;
	if (isAdministrator(user)) return true;
	if (!user.Roles) return false;

	for (let i = 0; i < user.Roles.length; i++) {
		const role = user.Roles[i];
		if (role.AccessTypeAccesses) {
			for (let a = 0; a < role.AccessTypeAccesses.length; a++) {
				if (role.AccessTypeAccesses[a].AccessTypeRight >= accessTypeAccess) {
					return true;
				}
			}
		}
	}
	return false;
}

function anyRoleHasModuleAccess(roles: Role[], accessTypeModuleKey: AccessTypeKey | string, accessTypeAccess: number) {
	for (let i = 0; i < roles.length; i++) {
		if (roles[i].AccessTypeAccesses) {
			for (let a = 0; a < roles[i].AccessTypeAccesses.length; a++) {
				const correctModule = roles[i].AccessTypeAccesses[a].AccessTypeModule.AccessTypeKey == accessTypeModuleKey;
				if (correctModule && roles[i].AccessTypeAccesses[a].AccessTypeRight >= accessTypeAccess) return true;
			}
		}
	}
	return false;
}
